import Api from '@/api/Api'

class Product extends Api {
  protected resource = 'browse-products'

  public async browse<T>(options = {}) {
    return await this.paginate<T>(options)
  }

  public async search<T>(options: {}) {
    return await this.paginate<T>(options, 'search')
  }

  public async highlights<T>(options: {}) {
    return await this.get<T>({
      paginate: false,
      //limit: 10,
      ...options
    })
  }

  public async featured<T>() {
    const { data, error, response } = await this.fetch(`${this.resource}/featured`).json<T>()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }

  public async popular<T>() {
    const { data, error, response } = await this.fetch(`${this.resource}/popular`).json<T>()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }

  public async bestSeller<T>() {
    const { data, error, response } = await this.fetch(`${this.resource}/best-seller`).json<T>()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }

  public async deals<T>() {
    const { data, error, response } = await this.fetch(`${this.resource}/deals`).json<T>()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }

  public async forYou<T>() {
    const { data, error, response } = await this.fetch(`${this.resource}/for-you`).json<T>()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }

  public async topRated<T>() {
    const { data, error, response } = await this.fetch(`${this.resource}/top-rated`).json<T>()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }

  public async newArrivals<T>() {
    const { data, error, response } = await this.fetch(`${this.resource}/new-arrivals`).json<T>()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }

  public async random<T>() {
    const { data, error, response } = await this.fetch(`${this.resource}/random`).json<T>()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }

  public async related<T>(id: number) {
    const { data, error, response } = await this.fetch(`${this.resource}/${id}/related`).json<T>()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }
}

export default new Product()
